import { connect } from 'react-redux';

import CreateForm from './components/CreateForm';

const mapStateToProps = (state) => ({
  authenticatedID: (state.auth.sub || null),
  authedUser: state.auth,
});

export default (store) => ({
  path : 'create',
  component: connect(mapStateToProps)(CreateForm),
});



// WEBPACK FOOTER //
// ./src/routes/company/routes/Jobs/routes/Create/index.js